export default function FooterSection() {
  const currentYear = 2026;
  return (
    <footer className="bg-stone-100 border-t border-stone-200 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img
              src="https://static.readdy.ai/image/76f94b045f9b93f74f066d244037d990/428c6cd2fb47a0ddcb957948b924a1cf.png"
              alt="Logo"
              className="h-8 w-auto object-contain"
            />
            <p className="text-stone-700 text-sm font-semibold">Apolloan Global Limited · Hong Kong AI Ecosystem Scout</p>
            <p className="text-stone-500 text-xs tracking-widest">透明｜勤奮｜長期思維</p>
          </div>

          {/* Social links */}
          <div className="flex items-center gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-stone-200 text-stone-600 hover:text-amber-600 hover:border-amber-400 transition-colors cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-base" />
            </a>

          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-stone-200 text-center">
          <p className="text-stone-400 text-xs">&copy; {currentYear} All Rights Reserved · Built with Apolloan Global Limited</p>
        </div>
      </div>
    </footer>
  );
}
